<template>
  <div>
    <div
      :class="{ 'studio-page-header-long' : !is_sidebar_minimized }"
      class="studio-page-header"
      style="padding-bottom: 0 !important; padding-top: 15px !important; height: 110px">
      <div class="title-tab-experience-manager">ADMINISTRATOR</div>
      <div class="d-flex m__t--45">
        <template v-for="(tab, index) in tabMenu">
          <div
            v-if="tab.show"
            :key="tab.label"
            :class="[
              { 'm__r--35': index < tabMenu.length - 1 },
              tab.active ? 'tab-experience-manager-active' : 'tab-experience-manager'
            ]"
            @click="$router.replace(tab.url)"
          >
            {{ tab.label }}
          </div>
        </template>
      </div>
    </div>

    <div class="studio-page-administrator-content">
      <b-form-group
        class="company-profile-page card-body application-row"
        style="background-color: #ffffff">
        <div class="profile-page__body">
          <b-container fluid>
            <b-row>
              <b-col cols="4">
                <j-singleupload
                  :accepted-file-type="['jpg', 'png', 'jpeg']"
                  :api-token="tokenApi"
                  :img-default="company_profile.image_url"
                  :url-upload="url_upload"
                  @url="getNewProfileImage" />
                  <!-- <p>File extension: 'jpg', 'png', or 'jpeg' <br>Max file size: 5MB</p> -->
              </b-col>
              <b-col cols="8">
                <b-form-group class="profile-page__section">
                  <b-form-group :class="{'error-input' : $v.name.$error}">
                    <label
                      class="bold"
                      for="name">Name</label>
                    <j-input
                      id="name"
                      v-model="company_profile.name"
                      type="text"/>
                  </b-form-group>
                  <b-form-group :class="{'error-input' : $v.phone.$error}">
                    <label
                      class="bold"
                      for="phone">Phone Number</label>
                    <j-input
                      id="phone"
                      v-model="company_profile.phone"
                      type="text"/>
                  </b-form-group>
                  <b-form-group :class="{'error-input' : $v.phone_finance.$error}">
                    <label
                      class="bold"
                      for="phone_finance">Phone Finance</label>
                    <j-input
                      id="phone_finance"
                      v-model="company_profile.phone_finance"
                      type="text"/>
                  </b-form-group>
                  <b-form-group :class="{'error-input' : $v.web_url.$error}">
                    <label
                      class="bold"
                      for="web_url">Web Url</label>
                    <j-input
                      id="web_url"
                      v-model="company_profile.web_url"
                      type="text"/>
                  </b-form-group>
                  <b-form-group :class="{'error-input' : $v.address.$error}">
                    <label
                      class="bold"
                      for="address">Address</label>
                    <j-input
                      id="address"
                      v-model="company_profile.address"
                      type="text"/>
                  </b-form-group>
                  <b-form-group :class="{'error-input' : $v.description.$error}">
                    <label
                      class="bold"
                      for="description">Description</label>
                    <j-textarea
                      id="description"
                      :rows="3"
                      v-model="company_profile.description"/>
                  </b-form-group>
                  <!-- <b-form-group :class="{'error-input' : $v.created_date.$error}">
                    <label
                      class="bold"
                      for="created_date">Created date</label>
                    <j-input
                      id="created_date"
                      v-model="$v.created_date.$model"
                      type="text"/>
                  </b-form-group>
                  <b-form-group :class="{'error-input' : $v.updated_date.$error}">
                    <label
                      class="bold"
                      for="updated_date">Updated date</label>
                    <j-input
                      id="updated_date"
                      v-model="$v.updated_date.$model"
                      type="text"/>
                  </b-form-group> -->
                </b-form-group>
                <b-button
                  class="btn btn-import-form pull-right"
                  @click="updateCompanyProfile">
                  <i class="fa fa-cloud-upload"/>
                  Update
                </b-button>
              </b-col>
              <!-- <b-col cols="4">
                <j-singleupload
                  :accepted-file-type="['jpg', 'png', 'jpeg']"
                  :api-token="tokenApi"
                  :img-default="banner_default"
                  :url-upload="url_upload"
                  @url="getNewBannerURL" />
                <p>File extension: 'jpg', 'png', or 'jpeg' <br>
                  Max file size: 5MB<br> Size: 1920 x 350px</p>
                <b-button
                  class="btn blue icon align-right m__t--15"
                  @click="updateBanner">
                  <i class="fa fa-cloud-upload"/>
                  Update Banner
                </b-button>
              </b-col> -->
            </b-row>
          </b-container>
        </div>
      </b-form-group>
      <!--Error Screen-->
      <j-problem-screen
        ref="problemScreen"
        :message="error_prompt"/>
      <!--Loading Screen-->
      <j-loading-screen ref="loadingScreen"/>
      <!--Success Screen-->
      <j-success-screen
        ref="successScreen"
        :message="success_prompt"/>
    </div>
  </div>
</template>

<script>
/* eslint-disable import/no-duplicates,no-underscore-dangle */
import { required, integer } from 'vuelidate/lib/validators';
import Vue from 'vue';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'JProfilePage',
  data() {
    return {
      tokenApi: Vue.ls.get('Token'),
      id: -1,
      is_banner_uploaded: false,
      banner_default: '',
      img_default: '',
      error_prompt: '',
      success_prompt: '',
      company_profile: null,
      banner: null,
    };
  },
  computed: {
    ...mapState('jStoreCompanyProfile', ['state_company_profile']),
    ...mapState('jStoreSetting', ['is_sidebar_minimized']),
    ...mapState('jStoreLogin', ['profile_data']),

    role() {
      return Number(localStorage.getItem('userRole') || this.profile_data.userRole);
    },
    url_upload() {
      return `${process.env.GATE_URL}/file`;
    },
    tabMenu() {
      return [
        { url: '/administrator', label: 'USER', show: true, active: false },
        { url: '/administrator/position', label: 'POSITION', show: true, active: false },
        { url: '/administrator/unit', label: 'UNIT', show: true, active: false },
        { url: '/administrator/location', label: 'LOCATION', show: true, active: false },
        { url: '/administrator/layer', label: 'LAYER', show: true, active: false },
        { url: '/administrator/company/profile', label: 'COMPANY', show: true, active: true },
        { url: '/administrator/company/settings', label: 'SETTINGS', show: this.role === 1, active: false },
      ];
    },
  },
  watch: {
    // eslint-disable-next-line
    'state_company_profile.detail': function (data) {
      this.company_profile = {
        id: data.id,
        name: data.name,
        phone: data.phone,
        phone_finance: data.phone_finance,
        web_url: data.web_url,
        address: data.address,
        description: data.description,
        created_date: data.created_date,
        updated_date: data.updated_date,
        image_url: data.image_url,
      };
    },
    // eslint-disable-next-line
    'state_company_profile.banner': function (data) {
      this.banner = {
        id: data.id,
        url_banner: data.url_banner,
      };
      this.banner_default = this.banner.url_banner;
    },
  },
  created() {
    this.loadCompanyProfile();
    this.loadCompanyBanner();
  },
  methods: {
    ...mapActions('jStoreCompanyProfile', ['actionGetCompanyDetail', 'actionGetCompanyBanner', 'actionCreateCompanyBanner', 'actionUpdateCompanyProfile', 'actionUpdateCompanyBanner']),
    getNewProfileImage(data) {
      this.company_profile.image_url = data;
    },
    getNewBannerURL(data) {
      if (this.banner) {
        this.banner.url_banner = data;
        this.is_banner_uploaded = true;
      } else {
        this.banner = {
          url_banner: data,
        };
        this.is_banner_uploaded = true;
      }
    },
    loadCompanyProfile() {
      this.actionGetCompanyDetail();
    },
    loadCompanyBanner() {
      const bannerParameter = {
        page: 1,
        limit: 1,
        column: 'id',
        sort: 'asc',
      };
      this.actionGetCompanyBanner({ params: bannerParameter });
    },
    updateCompanyProfile() {
      if (this.company_profile !== null) {
        this.sendCompanyProfileData();
      }
    },
    sendCompanyProfileData() {
      if (this.company_profile !== null) {
        this.actionUpdateCompanyProfile(this.company_profile);
      }
    },
    sendBannerData() {
      if (this.banner !== null) {
        if (this.banner.id) {
          this.actionUpdateCompanyBanner(this.banner);
        } else {
          this.actionCreateCompanyBanner(this.banner);
        }
      }
    },
    updateBanner() {
      if (this.banner !== null) {
        this.sendBannerData();
      } else {
        this.error_prompt = 'Please Upload A Banner First!';
        this.$refs.loadingScreen.closeLoadingScreen();
        this.$refs.problemScreen.toggleProblemScreen();
      }
    },
  },
  validations: {
    name: {
      required,
    },
    phone: {
      integer,
    },
    phone_finance: {
      integer,
    },
    web_url: {
      required,
    },
    address: {
      required,
    },
    description: {
      required,
    },
    created_date: {
      required,
    },
    updated_date: {
      required,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/company/jCompanyProfile.vue